import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMapper from "@/assets/js/models/helpers/JsonMapper";
var _attributes = /*#__PURE__*/new WeakMap();
export default class UserWhatsappSettings extends JsonMapper {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [UserWhatsappSettings.group_invitation_url_attribute_name]: null
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getGroupInvitationUrlAttributeName() {
    return UserWhatsappSettings.group_invitation_url_attribute_name;
  }
  getGroupInvitationUrl() {
    return this.getAttribute(UserWhatsappSettings.getGroupInvitationUrlAttributeName());
  }
}
_defineProperty(UserWhatsappSettings, "group_invitation_url_attribute_name", 'group_invitation_url');